export default function ModerationRoute($stateProvider) {
	$stateProvider
		.state('portail.moderation', {
			url: '/moderation',
			abstract: true,
			template: '<ui-view></ui-view>',
			ncyBreadcrumb: {
				skip: true
				//label: '{{ "PORTAIL.BREADCRUMBS.PORTAIL" | translate}}',
			}
		})
		.state('portail.moderation.list', {
			url: '',
			rights: { domain: 'portail', right: 'read' },
			template: '<portail-moderation-list></portail-moderation-list>',
			ncyBreadcrumb: {
				skip: true
				//label: '{{ "PORTAIL.BREADCRUMBS.PORTAIL" | translate}}',
			},
			search: 'PORTAIL.BREADCRUMBS.MODERATION'
		});
}

ModerationRoute.$inject = ['$stateProvider'];
